import {useTranslation} from "@i18n";
import { CDN_LINK } from "@globalConfig";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import stl from "./Tag.module.css";
import { useState } from "react";

const Tag = ({ tags, value, onClick, withPopUp }) => {
  const [activeTag, setActiveTag] = useState(null);
  const [ShowPopUp, setShowPopUp] = useState(false);
  const [popUpData, setPopUpData] = useState({
    code: "",
    description: "",
  });
  const { t } = useTranslation(["web_checkout_cash"]);
  const handleClick = (tag) => {
    setActiveTag(tag);
    onClick(tag.code);
  };
  return (
    <>
      <div className={stl.container}>
        {tags?.map((tag) => {
          return (
            <span key={tag?.code}>
              <div
                onClick={(e) => {
                  e.target === e.currentTarget && handleClick(tag);
                }}
                className={stl.tagContainer}
              >
                <div
                  className={`${stl.tagAR} ${
                    tag === activeTag || tag.code === value
                      ? stl.active
                      : stl.inactive
                  }`}
                >
                  {tag.code}
                  {tag.description && (
                    <>
                      - <span>{tag.description}</span>
                    </>
                  )}
                  {withPopUp && (
                    <img
                      className="hasEvents"
                      onClick={() => {
                        setShowPopUp(true);
                        setPopUpData({
                          code: tag.code,
                          description: tag.popup_description,
                        });
                      }}
                      src={CDN_LINK + "/assets/images/gray-info-icon.svg"}
                      alt="info icon"
                    />
                  )}
                </div>
              </div>
            </span>
          );
        })}
      </div>

      <BottomSheetPopup
        show={ShowPopUp}
        onClose={() => {
          setShowPopUp(false);
        }}
        className={stl.customPopUp}
      >
        <div className={stl.popupContainer}>
          <strong>
            {t("كود خصم", {
              ns: "web_checkout_cash",
            })}
            ({popUpData.code})
          </strong>
          <p>{popUpData.description}</p>
        </div>
      </BottomSheetPopup>
    </>
  );
};

export default Tag;
